var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',[_c('span',{attrs:{"slot":"fixedtopbuttons"},slot:"fixedtopbuttons"},[_c('large-button',{on:{"click":function($event){_vm.$router.push('home')}}},[_vm._v("Home")])],1),_vm._v(" "),(_vm.help)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.help.htmlcontent)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d6feda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WPP.vue
// module id = 450
// module chunks = 1